import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hostPortSelector } from 'packages/store/platform/platform.selectors';
import { registerBynderUser } from 'packages/store/user/user.actions';
import { sanitizePathname } from 'packages/helpers/navigation';
import useThunkDispatch from 'packages/hooks/useThunkDispatch';

const useHistoryListener = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useThunkDispatch();
    const hostPort = useSelector(hostPortSelector);

    useEffect(() => {
        let hashChangeListener = () => {};

        if (hostPort) {
            let lastLocation = '';

            hashChangeListener = () => {
                const newLocation = location.pathname + location.search;

                if (lastLocation && lastLocation === newLocation) {
                    return;
                }

                lastLocation = newLocation;

                hostPort.postMessage({
                    type: 'hash_update',
                    hash: newLocation,
                });
            };

            if (['/not-found', '/no-access'].includes(location.pathname)) {
                hostPort.postMessage({
                    type: 'hash_update',
                    hash: location.pathname,
                });
            }

            if (location.pathname === '/bynder-auth') {
                const redirectPath = sanitizePathname(sessionStorage.getItem('redirectUrl') ?? '/');

                if (location.search) {
                    const searchParams = new URLSearchParams(location.search);
                    const authCode = searchParams.get('code');
                    const state = searchParams.get('state');

                    dispatch(registerBynderUser(authCode, state, () => navigate(redirectPath, { replace: true })));
                } else {
                    navigate(redirectPath, { replace: true });
                }
            }

            hashChangeListener();
        }

        return () => hashChangeListener();
    }, [hostPort, location, navigate, dispatch]);
};

export default useHistoryListener;
